module.exports = __webpack_public_path__ + "solution-build/img/resourceItem4@2.77865c72.jpg";